import axios from 'axios';

export class EntityResolver {
    /**
     * Validate if the universal ID matches the expected HANDLE-NUMBER format
     * @param {string} universalId - The universal ID to validate
     * @returns {boolean} - True if format is valid
     */
    static isValidFormat(universalId) {
        return /^[A-Z0-9]+[_-]\d+$/i.test(universalId);
    }

    /**
     * Resolve universal ID to entity data via API
     * @param {string} universalId - The universal ID to resolve
     * @returns {Promise<Object>} - Entity data with type, ID, and parent context
     */
    static async resolveEntity(universalId) {
        try {
            const response = await axios.get(`/resolve-entity/${universalId}`);
            return response.data;
        } catch (error) {
            // Re-throw with additional context
            if (error.response) {
                throw {
                    ...error,
                    message: error.response.data?.error || error.message,
                    status: error.response.status
                };
            }
            throw error;
        }
    }
}
